var map = {
	"./log-hist-en.png": 76573,
	"./log-hist-fa.png": 75179,
	"./predict-hist-en.png": 35996,
	"./predict-hist-fa.png": 74634,
	"./swap-hist-en.png": 48860,
	"./swap-hist-fa.png": 48970,
	"./wallet-hist-en.png": 68222,
	"./wallet-hist-fa.png": 31356
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33894;